module.exports = __webpack_public_path__ + "img/utmify.1f057afa.png";